import {Page} from "@/components/model/page";
import {OfferItem} from "@/components/model/offer-item";
import {http} from "@/components/http/http.service";

class ArchiveService {
    private readonly itemsPerPage = 8;

    loadPage(pageNumber: number): Promise<Page<OfferItem>> {
        return http.get(`/api/offer-items/archived?offset=${pageNumber * this.itemsPerPage}&limit=${this.itemsPerPage}`);
    }

    loadHighlight(numberOfItems: number): Promise<OfferItem[]> {
        return http.get(`/api/offer-items/archived/highlight?numberOfItems=${numberOfItems}`);
    }
}

export const archive = new ArchiveService();
